import { render, staticRenderFns } from "./s3-close-svg.vue?vue&type=template&id=5802c99c&"
import script from "./s3-close-svg.vue?vue&type=script&lang=js&"
export * from "./s3-close-svg.vue?vue&type=script&lang=js&"
import style0 from "./s3-close-svg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports